import { useTranslation } from 'react-i18next';
import { Card, CardContent, Box } from '@mui/material';

import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import DynamicSVG from '@/components/DynamicSvg';
import { ROUTES } from '@/route/routes.constants';
import { SafeLink } from '@/components/SafeLink';
import { useNavigationContext } from '@/hooks/useNavigationContext';
import styles from './ModuleCard.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/rootReducer';


export const ModuleCard: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {
    const { inspection, structure: module } = props;
    const { t: translate } = useTranslation();
    const { isBlocked, onBlockedNavigation } = useNavigationContext();
    const checkedModuleNames = useSelector((state: RootState) => state.openedInspection.inspection?.checkedModules) || '';
    const isChecked = checkedModuleNames.includes(module.name);
    if (!inspection) return null;


    return (
        <SafeLink
            to={`${ROUTES.INSPECTIONS}/${inspection.id}/${module.name}`}
            isBlocked={isBlocked}
            onBlockedNavigation={onBlockedNavigation}
            className={styles.link_no_deco} >
            <Card
                sx={{ padding: '.55rem 0', marginBottom: '.84rem', boxShadow: 'unset', borderRadius: '.28rem' }}>
                <CardContent className={styles.moduleCard}
                    sx={{
                        padding: '.55rem 2rem .55rem .55rem !important',
                        position: 'relative',
                        alignItems: 'center',

                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            // marginRight: '1.67rem',
                            padding: '0 1.67rem 0 1rem',
                            borderRight: '.11rem solid #e0e0e0', // Vertical line
                        }}
                    >
                        {!!module.icon && <DynamicSVG iconName={module.icon} />}
                    </Box>
                    {!!module.header && <span className={styles.moduleHeader}>{translate(module.header)}</span>}
                    <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center'}}>
                        {isChecked && !!module.checkedModuleIcon && <DynamicSVG iconName={module.checkedModuleIcon} />}  
                    </Box>
                </CardContent>
            </Card >
        </SafeLink>
    );
};
